/**
 * Calcula a melhor condição de preço.
 * - pvp_discount: mantém o PVP e aplica o desconto nos campos "Desc %" e "Desc €" da linha.
 * - cost_margin / fixed_price: aplica o novo preço no PVP (desconto da linha a zero).
 *
 * @param {number} basePrice - PVP base (preco_sem_iva)
 * @param {number} costPrice - Preço de custo
 * @param {Array} conditions - Regras de condição
 * @returns {{ unitPrice: number, desconto_per: number, valor_desconto: number }}
 */
export function calculateBestCondition(basePrice, costPrice, conditions) {
  const defaultResult = {
    unitPrice: basePrice,
    desconto_per: 0,
    valor_desconto: 0,
  };

  if (!conditions || conditions.length === 0) {
    return defaultResult;
  }

  let best = { ...defaultResult };
  let bestFinalUnitPrice = basePrice;

  conditions.forEach((cond) => {
    let unitPrice = basePrice;
    let desconto_per = 0;
    let valor_desconto = 0;
    let finalUnitPrice = basePrice;

    switch (cond.condition_type) {
      case "pvp_discount":
        unitPrice = basePrice;
        if (cond.discount_type === "percentage") {
          const pct = parseFloat(cond.value) || 0;
          desconto_per = Math.max(0, Math.min(100, pct));
          finalUnitPrice = basePrice * (1 - desconto_per / 100);
        } else if (cond.discount_type === "fixed_amount") {
          const fixed = parseFloat(cond.value) || 0;
          valor_desconto = Math.max(0, Math.min(basePrice, fixed));
          finalUnitPrice = basePrice - valor_desconto;
        }
        break;

      case "cost_margin":
        if (cond.discount_type === "percentage") {
          if (costPrice <= 0) {
            unitPrice = basePrice;
          } else {
            unitPrice = costPrice * (1 + parseFloat(cond.value) / 100);
          }
        } else if (cond.discount_type === "fixed_amount") {
          unitPrice = costPrice + parseFloat(cond.value);
        }
        if (unitPrice < 0) unitPrice = 0;
        finalUnitPrice = unitPrice;
        break;

      case "fixed_price":
        unitPrice = parseFloat(cond.value) || basePrice;
        if (unitPrice < 0) unitPrice = 0;
        finalUnitPrice = unitPrice;
        break;

      default:
        finalUnitPrice = basePrice;
        break;
    }

    if (finalUnitPrice < bestFinalUnitPrice) {
      bestFinalUnitPrice = finalUnitPrice;
      best = {
        unitPrice: Number(unitPrice.toFixed(3)),
        desconto_per,
        valor_desconto: Number(valor_desconto.toFixed(3)),
      };
    }
  });

  return best;
}
